import { gql } from '../../../../../hooks'

export const DELETE_LIMITS = gql`
  mutation AdministrationDeleteAnalysisLimits($id: ID!) {
    aDelete(path: "analysis/limits", id: $id) {
    }
  }
`

export const LIST_LIMITS = gql`
  query AdministrationListAnalysisLimits(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "analysis/limits"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
